module.exports = __webpack_public_path__ + "img/redo-disabled.6ae7b9dd.svg";